import { haveChannelsExpired } from './cachingStrategies/helpers';
import { DefaultCache, EPGCache } from './cachingStrategies';
import STORAGE_KEYS from '../../Storage/storageKeys';

export class APICache {
    constructor(onCacheUpdate, initialCache = {}) {
        const updateHandler = async (id, clear = false) => {
            await onCacheUpdate(id, this, clear);
        };
        const { CHANNELS, CHANNELS_BRIEF, EPG } = STORAGE_KEYS.API_CACHE;
        this.channelsBrief = new DefaultCache(
            CHANNELS_BRIEF,
            updateHandler,
            initialCache.channelsBrief
        );
        this.channels = new DefaultCache(
            CHANNELS,
            updateHandler,
            initialCache.channelsBrief,
            haveChannelsExpired
        );
        this.epg = new EPGCache(EPG, updateHandler, initialCache.epg, this.channelsBrief);
        this.epg.checkExpiration();
    }

    getCache() {
        return {
            channelsBrief: this.channelsBrief.cache,
            channels: this.channels.cache,
            epg: this.epg.cache
        };
    }

    async wipeCache() {
        await this.channelsBrief.wipeCache();
        await this.channels.wipeCache();
        await this.epg.wipeCache();
    }
}
